import React, { useEffect, useState } from "react";
import ImageHovered from "../imageHovered/imageHovered.js";
import Zoom from "../zoom/zoom.js";
import "./style.css";
export default function ImageComponent(props) {
    const { entry, imageLoader } = props;
    const [loaded, setLoaded] = useState(false);
    const [hovered, setHovered] = useState(false);
    const [zoomOpened, setZoomOpened] = useState(false);
    const [src, setSrc] = useState("");
    const responsiveHeight = window.innerWidth <= 425 ? 190
        : window.innerWidth <= 940 ? 240
            : 300;
    const imgStyles = props.aspectRatio ?
        {
            aspectRatio: props.aspectRatio + "",
        }
        : {
            minHeight: `${responsiveHeight}px`,
        };
    function getUrl() {
        if (imageLoader === "cloud-function") {
            if (location.host.startsWith("localhost")) {
                return `http://localhost:8082?imgName=${props.imageName}&gallery=${encodeURIComponent(props.galleryName)}&gId=${props.groupId}`;
            }
            return `https://content.fhub.pl?imgName=${props.imageName}&gallery=${encodeURIComponent(props.galleryName)}&gId=${props.groupId}`;
        }
        return `/api/public/users/gallery/image/${props.imageName}?gallery=${encodeURIComponent(props.galleryName)}&gId=${props.groupId}`;
    }
    useEffect(() => {
        if (props.inView == false)
            return;
        setSrc(getUrl());
    }, [props.inView]);
    useEffect(() => {
        if (!entry)
            return;
        if (src.length === 0 && (entry === null || entry === void 0 ? void 0 : entry.intersectionRatio) > 0)
            return setSrc(getUrl());
        if ((entry === null || entry === void 0 ? void 0 : entry.isIntersecting) === false && loaded !== true) {
            setLoaded(false);
            setSrc("");
        }
    }, [entry === null || entry === void 0 ? void 0 : entry.intersectionRatio]);
    function setIsHovered(isHovered) {
        setTimeout(() => setHovered(isHovered), 0);
    }
    return (React.createElement("div", { ref: props.reference, className: !loaded ? "image-container image-container-loading" : "image-container", onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), onClick: () => {
            if (!hovered) {
                return setIsHovered(true);
            }
        }, style: imgStyles },
        React.createElement("img", { className: "image ph-no-capture", alt: props.imageName, src: src, onLoad: () => {
                setLoaded(true);
            }, style: imgStyles }),
        hovered && (React.createElement(ImageHovered, { imageUrl: src, offers: props.offers, imageName: props.imageName, intentSource: "in-gallery-button", openZoom: () => {
                var _a;
                (_a = props.onZoom) === null || _a === void 0 ? void 0 : _a.call(props);
                setZoomOpened(true);
                setHovered(false);
            } })),
        React.createElement("div", { className: "hovered-zoom-image-name-container" }, props.imageName.replace(/\..*/, "")),
        zoomOpened && (React.createElement(Zoom, { imageName: props.imageName, onClosed: function () {
                var _a;
                (_a = props.onZoomExit) === null || _a === void 0 ? void 0 : _a.call(props);
                setZoomOpened(false);
                setHovered(false);
            } }))));
}
